import { isSameDay, formatDistance } from 'date-fns/esm';
import { TODAY } from '../../../../constants';
import { STATES } from '../../../../constants/states';
import template from './move-when-where.html';
import './move-when-where.global.css';

class MoveWhenWhereController {
  constructor($state) {
    'ngInject';
    Object.assign(this, { $state });
  }

  $onChanges(changes) {
    const {
      move: { currentValue: move },
    } = changes;

    if (move) {
      this.moveIsToday = isSameDay(move.date, TODAY);
      this.moveSummaryHref = this.$state.href(STATES.MOVES_SUMMARY, {
        moveId: move.id,
      });
    }
  }

  dateFnsFormatDistance(date) {
    return `${formatDistance(date, TODAY)} ${
      new Date(date).getTime() - TODAY.getTime() > 0 ? `Away!` : `Ago`
    } `;
  }
}

export const MoveWhenWhereComponent = {
  controller: MoveWhenWhereController,
  bindings: {
    move: '<',
  },
  template,
};
